import { Injectable } from '@angular/core';
import { ApiResponse } from 'src/app/shared/models/apiResponse';
import { ActiveProductService, AnalyticsService, AuthorizedApiService, FeatureFlagService } from '@laasy/common-layout';
import { Router } from '@angular/router';
import { ProfileCompletionService } from './profile-completion.service';
import { SegmentEvent } from 'src/app/shared/utilities/constants';
import { isProfileCompViewedOnceSessionKey } from '../auth-constants';

@Injectable({
  providedIn: 'root'
})
export class RedirectPostLoginService {

  constructor(private featureFlagService: FeatureFlagService,private apiService: AuthorizedApiService, private analyticsService: AnalyticsService, private router: Router, private profileCompletionService: ProfileCompletionService, private activeProductService: ActiveProductService) { }

  async redirectPostLogin(email: string, response: any={}) {
    const postLoginRedirect = sessionStorage.getItem("post-login-redirect")
    let _postLoginRedirect = null
    const defaultProduct = localStorage.getItem("defaultProduct")
    const isProfileCompViewedOnce = localStorage.getItem(isProfileCompViewedOnceSessionKey) === 'true';
    if (!isProfileCompViewedOnce && !this.featureFlagService.hidePostLoginSurvey) {
      const isUserProfileCompleted = await this.profileCompletionService.loginCheckProfileCompletion(email)
      if (!isUserProfileCompleted) {
        this.router.navigate(['/'])
        return
      }
    }

    this.activeProductService.setRole()

    this.triggerEventOnLogin(email)

    if (postLoginRedirect) {
      try {
        _postLoginRedirect = decodeURIComponent(escape(atob(postLoginRedirect)));
      } catch (error) {
        // Silent error handling
        _postLoginRedirect = null;
      }
      sessionStorage.removeItem("post-login-redirect")
    }
    else if (defaultProduct) {
      _postLoginRedirect = defaultProduct
    }

    this.analyticsService.segmentTrackEvent({ email: email, redirectPostLogin: _postLoginRedirect ?? window.location.origin }, SegmentEvent.loggedInRedirect);

    if (_postLoginRedirect) {
      window.location.href = _postLoginRedirect
    } else {
      this.router.navigate(['/'])
    }

  }

  triggerEventOnLogin(email: string) {
    const request = JSON.stringify(
      {
        'eventName': 'user_login',
        'eventData': `{\"email\":\"${email}\"}`
      }
    )
    this.apiService.post<ApiResponse>(`user/api/usermanagement/triggerEvent`, request)
      .toPromise()
      .catch(() => {
        // Silently handle the error to prevent unhandled promise rejections
        return null;
      });
  }
}
